import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import ProductProvider from "./contexts/ProductContext";
import SidebarProvider from "./contexts/SidebarContext";
import CartProvider from "./contexts/CartContext";
import BusinessProvider from "./contexts/BusinessContext";
import WidgetChatBot from "./components/WidgetChatBot";
import StyledToaster from "./common/toaster";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BusinessProvider>
    <StyledToaster />
    <SidebarProvider>
      <CartProvider>
        <ProductProvider>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </ProductProvider>
      </CartProvider>
    </SidebarProvider>
    <div>
      <WidgetChatBot />
    </div>
  </BusinessProvider>
);
